import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,2 C1489.35529,2 1920,432.644706 1920,962 C1920,1491.35529 1489.35529,1922 960,1922 C430.644706,1922 0,1491.35529 0,962 C0,432.644706 430.644706,2 960,2 Z M960,114.941176 C492.875294,114.941176 112.941176,494.875294 112.941176,962 C112.941176,1429.12471 492.875294,1809.05882 960,1809.05882 C1427.12471,1809.05882 1807.05882,1429.12471 1807.05882,962 C1807.05882,494.875294 1427.12471,114.941176 960,114.941176 Z M1396.704,635.232 L1121.504,635.232 L757.450667,635.232 L482.144,635.232 C451.104,635.232 426.677333,659.658667 426.677333,690.698667 C426.677333,721.845333 451.104,746.272 482.144,746.272 L757.450667,746.272 L757.450667,1125.792 L757.450667,1259.01867 L757.450667,1634.05867 C757.450667,1665.20533 781.770667,1689.632 812.917333,1689.632 C843.957333,1689.632 868.384,1665.20533 868.384,1634.05867 L868.384,1259.01867 L1014.83733,1259.01867 L1014.83733,1634.05867 C1014.83733,1665.20533 1039.264,1689.632 1070.304,1689.632 C1101.45067,1689.632 1125.87733,1665.20533 1125.87733,1634.05867 L1125.87733,1259.01867 L1125.87733,1125.792 L1125.87733,744.032 L1401.184,744.032 C1432.224,744.032 1456.65067,719.605333 1456.65067,688.565333 C1449.93067,659.658667 1425.61067,635.232 1396.704,635.232 M939.413333,320.021333 C1013.01333,320.021333 1072.64,379.648 1072.64,453.248 C1072.64,526.741333 1013.01333,586.368 939.413333,586.368 C865.92,586.368 806.186667,526.741333 806.186667,453.248 C806.186667,379.648 865.92,320.021333 939.413333,320.021333",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconA11yLine = /*#__PURE__*/function (_Component) {
  _inherits(IconA11yLine, _Component);

  var _super = _createSuper(IconA11yLine);

  function IconA11yLine() {
    _classCallCheck(this, IconA11yLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconA11yLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconA11y",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconA11yLine.displayName = "IconA11yLine";
  return IconA11yLine;
}(Component);

IconA11yLine.glyphName = 'a11y';
IconA11yLine.variant = 'Line';
IconA11yLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconA11yLine;
export { IconA11yLine };